<template>
  <ipo3-page>
    <template slot="title">{{form_name}}</template>
    <template slot="tools">
      <el-button type="primary" @click="goBack" icon="el-icon-back">{{$t('btns.back')}}</el-button>
    </template>
    <template slot="page">
      <div id="popup-edit">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-form-item label="語言" prop="type">
            <el-select v-model="ruleForm.language" style="margin-right: 14px;">
              <el-option v-for="item in languages" :key="item.name" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="跳轉URL">
            <el-input placeholder="https://" v-model="ruleForm.url"></el-input>
          </el-form-item>

          <el-form-item label="彈窗名稱">
            <el-input placeholder="請輸入彈窗名稱" v-model="ruleForm.name"></el-input>
          </el-form-item>
         
         <el-form-item label="封面圖（於網站顯示）" prop="image2">
           <ipo3-upload @success="onSuccess2" ref="upload2"></ipo3-upload>
         </el-form-item>

          <el-form-item label="封面圖（於手機顯示）" prop="image">
            <ipo3-upload @success="onSuccess" ref="upload"></ipo3-upload>
          </el-form-item>

          <el-form-item label="開始日期">
            <el-date-picker
              v-model="ruleForm.date_from"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="選擇日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="結束日期">
            <el-date-picker
              v-model="ruleForm.date_to"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="選擇日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="自動關閉（0：不自動關閉）">
            <el-input placeholder="0" v-model="ruleForm.auto_close"></el-input>
          </el-form-item>  

          <el-form-item label="是否顯示" prop="status">
            <el-switch v-model="ruleForm.status"></el-switch>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <el-drawer
        title="新聞綁定"
        :visible.sync="drawer"
        :direction="direction"
        :with-header="true"
        :close-btn="false"
        :before-close="handleClose"
      >      
    <template slot="title">
            <el-input v-model="title" placeholder="查找"></el-input>
    </template>
        <div class="page_view">    
          <el-table
            ref="tableArr"
            v-loading="isLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            :header-cell-style="getRowClass"
          >
            <template v-for="item in items">
              <el-table-column
                :key="item.name"
                header-align="center"
                align="center"
                :label="item.name"
                :prop="item.id"
              ></el-table-column>
            </template>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              class="operate"
              width="160"
            >
              <template scope="scope">
                <div>
                  <el-button @click="onHandle(scope.row)" size="mini" type="success">選擇</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10,20,30,40,100]"
            :page-size="paginate"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagecount"
          ></el-pagination>
        </div>
      </el-drawer>
    </template>
  </ipo3-page>
</template>
<script>
export default {
  name: "popup-edit",
  data() {
    return {
      languages: [{id: 'tw', name: '中文繁體'}, {id: 'cn', name: '中文简体'}, {id: 'en', name: '英文'}],
      drawer: false,
      direction: "rtl",
      tableData: [],
      form_name: '添加彈窗',
      currentPage: 1,
      pagecount: 1,
      paginate: 5,
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "title" }
      ],
      title: '',
      news: null,
      edit: false,
      ruleForm: {
        language: 'tw',
        id: 0,
        url: "",
        name: "",
        date_from: "",
        date_to: "",
        status: true,
        auto_close: 0,
        image: "",
        image2: ""
      }
    };
  },

  created() {
    if (this.$route.params.id !== undefined) {
      this.edit = true;
      this.ruleForm.id = this.$route.params.id;
      this.getData(this.$route.params.id);
      this.form_name = "編輯彈窗"
    } else {
      this.ruleForm.language = this.$route.query.language;
    }
  },

  watch: {
    title: {
      async handler(newVal) {
        this.currentPage = 1;
        this.getNewsData();
      },
      immediate: true,
    }
  },

  methods: {
    getData(id) {
      var self = this;
      this.$http.get("/admin/popup/detail", { id: id }).then(res => {
        self.ruleForm = res.data;
        self.$refs.upload.setImage({
          url: self.ruleForm.image,
          name: "news.jpg"
        });
        self.$refs.upload2.setImage({
          url: self.ruleForm.image2,
          name: "news.jpg"
        });
        self.ruleForm.status = self.ruleForm.status==1?true:false;
        /*
        self.news = res.data.news;
        if(self.news)
        {
          self.ruleForm.news_id = self.news.id;
        }
        */
      });
    },
    onSuccess(image) {
      this.ruleForm.image = image.path;
    },
    onSuccess2(image) {
      this.ruleForm.image2 = image.path;
    },
    onSelect() {
      this.getNewsData();
      this.drawer = true;
    },
    getNewsData() {
      let self = this;
      this.$http.get("/admin/news/index", {page: this.currentPage, size: this.paginate, language: this.ruleForm.language, title: this.title}).then(res => {
        let {data,total} = res.data;
        self.pagecount = total;
        self.tableData = res.data.data;
      });
    },
    onHandle(value) {
      this.news = value;
      this.ruleForm.name = value.title;
      this.drawer = false;
    },
    onSubmit() {
      let params = Object.assign({},this.ruleForm);
      params.status = params.status ? 1 : 0;

      //if (this.news == null) {
      //  this.$message.error("請選擇新聞");
      //  return;
      //}
      //params.news_id = this.news.id;

      this.$http.post("/admin/popup/edit", params).then(res => {
        console.log("res:", res);
        this.$message.success("編輯成功");
      });
    },
    handleSizeChange(size)
    {
      this.paginate = size;
      this.getNewsData(1,size);
    },

    handleCurrentChange(val)
    {
      this.currentPage = val;
      this.getNewsData();
    },
  }
};
</script>

<style lang="less">
#popup-edit {
  width: 800px;
  text-align: left;
}
</style>
